import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'
import moment from 'moment'

import JoinAction from '../action/join'
import Icon from '../../icon'
import Typography from '../../typography'
import RawHTML from '../../../common/raw-html'

import { useBreakpoint } from '../../../../hooks/breakpoint'

import ChevronUp from '../../icon/chevron-up.svg'
import ChevronDown from '../../icon/chevron-down.svg'

const Webinar = ({ webinar, ...attrs }) => {
  moment.locale('es')

  const breakpoint = useBreakpoint()
  const [isActive, setIsActive] = useState()

  const beginTime = moment(webinar.beginTime)
  const endTime = moment(webinar.endTime)

  attrs.className = classNames(
    attrs.className,
    [
      'border-t',
      'border-gray-300'
    ]
  )

  return <div
    {...attrs}>
    <div
      className={
        classNames([
          'flex',
          'flex-row',
          'items-center'
        ])
      }>
      {
        isActive
          ? null
          : <div
            className={
              classNames([
                'flex',
                'flex-row',
                'items-center',
                'mr-4'
              ])
            }>
            <div>
              <Typography
                size={'eight'}
                weight={'bold'}
                className={'text-green-500 mr-2'}>
                {beginTime.format('DD')}
              </Typography>
            </div>
            <div
              className={'flex flex-col'}>
              <div>
                <Typography
                  size={'one'}
                  weight={'regular'}
                  className={'text-green-500 capitalize'}>
                  {beginTime.format('ddd')}
                </Typography>
              </div>
              <div>
                <Typography
                  size={'one'}
                  weight={'regular'}
                  className={'text-green-500 capitalize'}>
                  {beginTime.format('MMM')}
                </Typography>
              </div>
            </div>
          </div>
      }
      <div
        className={
          classNames([
            'flex',
            'flex-row',
            'items-center',
            'flex-grow',
            'py-2',
            isActive ? 'text-green-600' : 'text-gray-500'
          ])
        }
        onClick={() => setIsActive(!isActive)}>
        <Typography
          size={breakpoint.mdAndUp ? 'four' : 'three'}
          weight={'medium'}>
          {beginTime.format('HH:mm a')}
          {' '}
          {webinar.title}
        </Typography>
        <Icon
          height={24}
          width={24}
          svg={isActive ? ChevronUp : ChevronDown}
          className={'flex-none ml-4'} />
      </div>
      {
        breakpoint.mdAndUp
          ? <div
            className={
              classNames([
                'flex-none',
                'md:ml-4',
                'py-7'
              ])
            }>
            <JoinAction
              webinar={webinar} />
          </div>
          : null
      }
    </div>
    {
      isActive
        ? <div
          className={'pt-4 md:pt-0 pb-4'}>
          <Typography
            tag={'div'}
            size={'three'}
            weight={'regular'}
            className={'mb-4'}>
            {beginTime.format('DD')}
            {' '}
            {beginTime.format('MMM')}
            {', '}
            {beginTime.format('HH:mm a')}
            {' - '}
            {endTime.format('HH:mm a')}
          </Typography>

          <Typography
            tag={'div'}
            size={'three'}
            weight={'regular'}>
            <RawHTML html={webinar.summary} />
          </Typography>
        </div>
        : null
    }
    {
      breakpoint.smOnly
        ? <div
          className={
            classNames([
              'flex-none',
              'md:ml-4',
              'py-7'
            ])
          }>
          <JoinAction
            webinar={webinar} />
        </div>
        : null
    }
  </div>
}

Webinar.propTypes = {
  webinar: PropTypes.object
}

const Upcomming = ({ title, text, webinars, ...attrs }) => {
  const breakpoint = useBreakpoint()

  const hasWebinars = get(webinars, 'items.length', 0) > 0

  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'pt-8',
      'md:pt-20',
      'pb-10',
      'md:pb-0'
    ]
  )

  return <section {...attrs}>
    <div
      className={
        classNames(
          [
            'relative',
            'container',
            'px-4'
          ]
        )
      }>
      <div
        className={
          classNames(
            [
              'flex',
              'flex-row',
              'flex-wrap',
              'items-start',
              '-mx-4'
            ],
            {
              'mb-10': webinars.length > 0
            }
          )
        }>
        <div
          className={
            classNames([
              'relative',
              'px-4'
            ])
          }
          style={{
            flexBasis: breakpoint.lgAndUp ? '35%' : (breakpoint.mdAndUp ? '50%' : '100%')
          }}>
          <Typography
            size={breakpoint.mdAndUp ? 'eight' : 'six'}
            weight={'bold'}
            className={'text-green-500'}>
            {title}
          </Typography>
        </div>
        <div
          className={
            classNames(
              [
                'relative',
                'px-4'
              ]
            )
          }
          style={{
            flexBasis: breakpoint.lgAndUp ? '50%' : (breakpoint.mdAndUp ? '50%' : '100%')
          }}>
          <Typography
            size={breakpoint.mdAndUp ? 'four' : 'three'}
            weight={'regular'}>
            {text}
          </Typography>
        </div>
      </div>

      {
        hasWebinars
          ? <div
            className={
              classNames([
                breakpoint.mdAndUp ? '' : 'relative',
                'container'
              ])
            }>
            {
              get(webinars, 'items', []).map(
                (transmission, index) => {
                  return <Webinar
                    key={transmission.id}
                    webinar={transmission} />
                }
              )
            }
          </div>
          : null
      }
    </div>
    {
      breakpoint.mdAndUp
        ? <div
          className={
            classNames(
              [
                'relative',
                'bg-red-500',
                webinars.length > 0 ? 'pt-20' : 'pt-10'
              ]
            )
          }>
          <div
            className={
              classNames([
                'absolute',
                'top-0',
                'right-0',
                'bottom-0',
                'left-0',
                'bg-white'
              ])
            }
            style={{
              borderRadius: '0 0 5rem 5rem'
            }}>
          </div>
        </div>
        : null
    }
  </section>
}

Upcomming.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  webinars: PropTypes.object
}

export default Upcomming
